/** Format a millisecond duration as HH:MM:SS (or MM:SS when under an hour). */
export function formatDuration(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '00:00';
  const totalSec = Math.floor(ms / 1000);
  const s = totalSec % 60;
  const m = Math.floor(totalSec / 60) % 60;
  const h = Math.floor(totalSec / 3600);
  const pad = (n: number) => String(n).padStart(2, '0');
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}

/** Format byte counts as MB with one decimal, or "-" if null. */
export function formatMb(bytes: number | null): string {
  if (bytes === null || !Number.isFinite(bytes)) return '—';
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Lossy truncate that keeps the head and tail of a long string. */
export function truncateMiddle(s: string, max = 60): string {
  if (s.length <= max) return s;
  const half = Math.floor((max - 1) / 2);
  return `${s.slice(0, half)}…${s.slice(s.length - half)}`;
}
